<p-table [value]="rows"
         [paginator]="true"
         [rows]="10"
         [showCurrentPageReport]="true"
         currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
         [rowsPerPageOptions]="[10,25,50]"
         [loading]="loading"
         styleClass="p-datatable-sm">

  <ng-template pTemplate="header">
    <tr class="text-sm">
      <th>Name</th>
      <th>Type</th>
      <th>SP</th>
      <th>Day Range</th>
      <th>Time</th>
      <th>Golfdigg</th>
      <th>TPC</th>
      <th>Hot Deal</th>
      <th>Golfer</th>
      <th>Party</th>
      <th>Free</th>
      <th>Cart</th>
      <th>From-To</th>
      <th>Actions</th>
    </tr>
  </ng-template>

  <!-- @formatter:off-->
    <ng-template pTemplate="body" let-priceRule>
        <tr>
            <td>
              <p class="text-sm" [class.line-through]="!priceRule.isActive">{{priceRule.name}}</p>
            </td>
            <td>
              <p-tag [value]="priceRule.priceType === 'WEEKDAY' ? 'WD' : 'WE'"
                     [severity]="priceRule.priceType === 'WEEKDAY' ? 'success' : 'warning'"
                     styleClass="text-xs px-1 py-0">
              </p-tag>
            </td>
          <td>
            <span *ngIf="priceRule.specialPrice === true" class="p-tag p-tag-warning text-xs">SP</span>
          </td>
            <td><app-day-range-display [days]="priceRule.days"></app-day-range-display></td>
            <td>
              <div class="text-xs">{{priceRule.tstart}}</div>
              <div class="text-xs">{{priceRule.tend}}</div>
            </td>
            <td>
                <app-price-display
                  [sale]="priceRule.map[1]?.sale"
                  [base]="priceRule.map[1]?.base"></app-price-display>
            </td>
            <td>
              <app-price-display
                [sale]="priceRule.map[2]?.sale"
                [base]="priceRule.map[2]?.base"></app-price-display>
            </td>
            <td>
                <div *ngIf="priceRule.enableHotDeal">
                  <app-price-display
                    [sale]="priceRule.hotDealPrices[3]?.price"
                    [base]="priceRule.hotDealPrices[3]?.base"></app-price-display>
                </div>
            </td>
            <td class="text-sm">{{priceRule.minperson}}–{{priceRule.maxperson}}</td>
            <td class="text-center">
                <i class="pi" [ngClass]="priceRule.party ? 'pi-check text-green-500' : 'pi-times text-red-500'"></i>
            </td>
            <td class="text-center">
              <span *ngIf="!priceRule.freeCart" class="p-tag text-xs bg-blue-300 mr-1">CT</span>
              <span *ngIf="!priceRule.freeCaddy" class="p-tag text-xs bg-pink-300">CD</span>
            </td>
            <td class="text-xs">
              <span *ngIf="priceRule.cartSetting?.active; else showPrice">Default</span>
              <ng-template #showPrice>
                <span class="">{{ priceRule.cartSetting?.priceSale | number}}
                </span>
                <i class="pi pi-info-circle text-xs ml-1 text-orange-500 cursor-pointer"
                   pTooltip="Cart setting details"
                   tooltipPosition="top"
                   (click)="cartSetting = priceRule.cartSetting"></i>
              </ng-template>
            </td>
            <td>
                  <app-date-range-status
                    [start]="priceRule.season.start"
                    [end]="priceRule.season.end"
                    styleClass="text-xs"></app-date-range-status>
            </td>
            <td>
              <div class="flex flex-column align-items-start gap-1">
                <p-splitButton
                  label="View"
                  styleClass="p-button-secondary"
                  (onClick)="onViewPriceRule(priceRule)"
                  (onDropdownClick)="handleActionsClick(priceRule)"
                  [model]="actionButtons"
                  [appendTo]="'body'">
                </p-splitButton>

                <div class="text-xs text-gray-500" pTooltip="{{priceRule.updated| date:'dd/MM/yyyy'}}">{{priceRule.updated| dayAgo}}</div>
              </div>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="13" class="text-center">No price rules found.</td>
        </tr>
    </ng-template>
</p-table>

<!-- Cart Setting Dialog -->
<p-dialog
  header="Cart Setting Details"
  [(visible)]="cartSetting"
  [style]="{width: '450px'}"
  [modal]="true"
  styleClass="p-fluid"
  [draggable]="false"
  [resizable]="false">

  <ng-template pTemplate="header">
    <div class="flex align-items-center">
      <i class="pi pi-shopping-cart text-primary mr-2"></i>
      <span class="font-medium">Cart Setting Details</span>
    </div>
  </ng-template>

  <div *ngIf="cartSetting" class="p-4">
    <!-- Status Section -->
    <div class="mb-4">
      <h5 class="text-lg font-medium mt-0 mb-3">Status</h5>
      <div class="grid">
        <div class="col-12 mb-2 flex align-items-center">
          <i class="pi" [ngClass]="cartSetting.require ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-500'"></i>
          <span class="ml-2">Require: <span class="font-medium">{{ cartSetting.require ? 'Yes' : 'No' }}</span></span>
        </div>

        <div class="col-12 mb-2 flex align-items-center">
          <i class="pi" [ngClass]="cartSetting.maxRequire ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-500'"></i>
          <span class="ml-2">Max Require: <span class="font-medium">{{ cartSetting.maxRequire ? 'Yes' : 'No' }}</span></span>
        </div>

        <div class="col-12 mb-2 flex align-items-center">
          <i class="pi" [ngClass]="cartSetting.sale ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-500'"></i>
          <span class="ml-2">Sale: <span class="font-medium">{{ cartSetting.sale ? 'Yes' : 'No' }}</span></span>
        </div>
      </div>
    </div>

    <!-- Pricing Section -->
    <div>
      <h5 class="text-lg font-medium mt-0 mb-3">Pricing</h5>
      <div class="grid">
        <div class="col-12 mb-2 flex align-items-center">
          <div class="flex align-items-center justify-content-between w-full">
            <div class="flex align-items-center">
              <i class="pi pi-tag text-blue-500 mr-2"></i>
              <span>Original Price:</span>
            </div>
            <span class="font-bold">{{ cartSetting.priceOriginal | currency }}</span>
          </div>
        </div>

        <div class="col-12 mb-2 flex align-items-center">
          <div class="flex align-items-center justify-content-between w-full">
            <div class="flex align-items-center">
              <i class="pi pi-percentage text-green-500 mr-2"></i>
              <span>Sale Price:</span>
            </div>
            <span class="font-bold text-green-600">{{ cartSetting.priceSale | currency }}</span>
          </div>
        </div>

        <div class="col-12 flex align-items-center">
          <div class="flex align-items-center justify-content-between w-full">
            <div class="flex align-items-center">
              <i class="pi pi-dollar text-orange-500 mr-2"></i>
              <span>Base Price:</span>
            </div>
            <span class="font-bold">{{ cartSetting.priceBase | currency }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Close" icon="pi pi-times"
            class="p-button-text" (click)="cartSetting = null"></button>
  </ng-template>
</p-dialog>
